import DetailStepsView from "./DetailStepsView";
import React from "react";

const OptionSelector = ({childNavigationData, slideToMainHandler}) => {
  const stepObject = childNavigationData?.navigationSteps;

  if (stepObject?.stepType === "COLORWAY") {
    return null;
  }

  return (
    <div className={"option-subwrap"}>
      <div className={"option-subwrap-inner"}>
        <div className={"option-h1"} data-expand={true}>
          {stepObject && (
            <DetailStepsView
              navigationDataObject={childNavigationData}
              stepObject={stepObject}
              slideToMainHandler={slideToMainHandler}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default OptionSelector;
